import { memo } from 'react';
import { SVGPropsIcon } from 'src/types';

const CloseBannerIcon = (props: SVGPropsIcon) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      color="#1DCDC3"
      {...props}>
      <path
        d="M7.98 6.20058L11.6924 2.48822C12.1025 2.07804 12.1025 1.41304 11.6924 1.0035L11.1975 0.508598C10.7872 0.0982918 10.1222 0.0982918 9.71262 0.508598L6.00038 4.22083L2.28802 0.507828C1.87784 0.0976509 1.21284 0.0976509 0.803307 0.507828L0.307633 1.00273C-0.102544 1.41304 -0.102544 2.07804 0.307633 2.48758L4.02064 6.20058L0.308402 9.91282C-0.101903 10.3231 -0.101903 10.9881 0.308402 11.3977L0.803307 11.8926C1.21348 12.3027 1.87848 12.3027 2.28802 11.8926L6.00038 8.1802L9.71262 11.8926C10.1229 12.3027 10.7879 12.3027 11.1975 11.8926L11.6924 11.3977C12.1025 10.9874 12.1025 10.3224 11.6924 9.91282L7.98 6.20058Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default memo(CloseBannerIcon);
